export const Role = {
    admin: "administrator",
    user: "User",
    combination_user:"combination_user"
}
